<span *ngIf="overlay" [hidden]="!arrow" class="popup__arrow" [ngStyle]="{'top.px': arrowTop}"></span>
<ng-content></ng-content>
